import PlusColumnSwiper from '../../../views/plus/ColumnSwiper.vue';

// プラス！コンテンツ
window.Vue.component('plus-column-swiper', PlusColumnSwiper);
